import { Col, Row, Card } from "reactstrap";
import { Theme } from '../../../config/constants';

const ReportListLoadingWidget = () => {
    return (
        <Card>
            <Row style={{ height: 'calc(100vh - 170px)' }}>
                <Col style={{overflowY: 'auto', height: '100%', textAlign: 'center', alignContent: 'center'}}>
                    <div className='spinner-border' style={{color: Theme().colors.primary}} role='status'>
                        <span className='visually-hidden'>Loading...</span>
                    </div>
                </Col>
            </Row>
        </Card>
    )
}

export default ReportListLoadingWidget;